// lib
import { getCurrentTime } from '$lib/utilities/dateTime';
import { getCookie, setCookie } from '$lib/utilities/cookie';

export const getNextPayoutDate = (format = 'LLL dd, yyyy') => {
	const date = getCurrentTime().set({
		hour: 23,
		minute: 59,
		second: 59,
	});

	if (+date.toFormat('dd') >= 15) {
		return date.set({ day: 15 }).plus({ months: 1 }).toFormat(format);
	} else {
		return date.set({ day: 15 }).toFormat(format);
	}
};

export const handleLgid = (url: URL) => {
	const lgid = url.searchParams.get('lgid');

	if (document !== undefined && lgid !== null && getCookie('lgid') === null)
		setCookie('lgid', lgid, 90);
};
